module.exports = __webpack_public_path__ + "static/img/CN@3x.75e1c824.jpg";